import type { App, ChainInfo, NetworkInfo } from "@alch/dx-entities";
import { Link } from "@alch/ui";
import NetworkEmblem from "@components/ui/icons/NetworkEmblem";
import { useUpdateAppNetworkAllowlist } from "@features/app-details-multi-network/networks/useUpdateAppNetworkAllowlist";
import networkNameWithoutChain from "@util/networkNameWithoutChain";
import clsx from "clsx";

interface NetworkItemProps {
  networkInfo: NetworkInfo;
  chainInfo?: ChainInfo;
  app?: App;
  disabled?: boolean;
}

const NetworkItem = ({
  networkInfo,
  chainInfo,
  disabled,
  app,
}: NetworkItemProps) => {
  // Show the network name without chain name if optional chainInfo is provided
  const networkName = chainInfo
    ? networkNameWithoutChain({ networkInfo, chainInfo })
    : networkInfo.name;

  const mutation = useUpdateAppNetworkAllowlist({ scopeId: app?.sid });

  return (
    <div className="flex items-center gap-4">
      <div
        className={clsx(
          "flex items-center gap-2",
          disabled ? "opacity-50" : undefined,
        )}
      >
        <NetworkEmblem networkInfo={networkInfo} className="size-5" />

        <span className="text-secondary">{networkName}</span>
      </div>

      {app && disabled ? (
        <Link
          size="xs"
          disabled={mutation.isPending}
          onClick={() =>
            mutation.mutate({
              appId: app.sid,
              networkIds: [...app.networkAllowlist, networkInfo.id],
            })
          }
        >
          Enable
        </Link>
      ) : null}
    </div>
  );
};

export default NetworkItem;
